var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useState } from 'react';
const Image = (props) => {
    const { name } = props, rest = __rest(props, ["name"]);
    const [image, setImage] = useState(null);
    useEffect(() => {
        import(/* webpackMode: "eager" */ `app/images/${name}`)
            .then((module) => setImage(module))
            .catch(() => import(/* webpackMode: "eager" */ 'app/images/avatar-undefined.png').then((module) => setImage(module)));
        return () => {
            setImage(null);
        };
    }, [name]);
    if (!image) {
        return React.createElement("img", { alt: 'not found' });
    }
    return React.createElement("img", Object.assign({ src: image.default, alt: image.name }, rest));
};
export default Image;
